import {
  TEntityResponse,
  TEntityListResponse,
  TErrorTypeResBody,
  TErrorTypeSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TErrorsClient = {
  get(id: string): Promise<TEntityResponse<'error-type', TErrorTypeResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'error-type', TErrorTypeSummaryResBody> | undefined>;
};

function ErrorsClient(apiClient: TAPIClient): TErrorsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'error-type', TErrorTypeResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'error-type', TErrorTypeResBody>>(`/error-types/${id}`);

      if (data && data.type !== 'error-type') {
        throw new Error('Invalid entity type received, expected: error-type, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'error-type', TErrorTypeSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'error-type', TErrorTypeSummaryResBody>>(
        `/error-types?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'error-type') {
        throw new Error('Invalid entity type received, expected: error-type, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TErrorsClient, ErrorsClient };
